"use strict";
var ACC;

ACC.customerservice = {

    _autoload: [
		"removeHeadingLevelOne"
	],

    removeHeadingLevelOne: function() {
        const body = document.body;
        const classNames = body.className;

        if (!classNames.includes('pageLabel--customer-service')) {
            return;
        }

        const container = document.getElementsByClassName("homepage-content-container");

        if (container.length > 0) {
            const headingLevelOne = container[0];

            if (headingLevelOne.firstElementChild.tagName === "H1") {
                headingLevelOne.firstElementChild.remove();
            }
            
        }
        
    }
};